import { toHex } from './encode.js';

export function randomBytes(length: number): Uint8Array {
  const arr = new Uint8Array(length);
  crypto.getRandomValues(arr);
  return arr;
}

const DEFAULT_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export function randomString(length: number, alphabet = DEFAULT_ALPHABET): string {
  const bytes = randomBytes(length);
  let out = '';
  for (let i = 0; i < length; i++) {
    out += alphabet[(bytes[i] as number) % alphabet.length];
  }
  return out;
}

export function uuidV4(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const bytes = randomBytes(16);
  bytes[6] = ((bytes[6] as number) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] as number) & 0x3f) | 0x80;
  const hex = toHex(bytes);
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function uuidV7(): string {
  const now = BigInt(Date.now());
  const bytes = new Uint8Array(16);
  bytes[0] = Number((now >> 40n) & 0xffn);
  bytes[1] = Number((now >> 32n) & 0xffn);
  bytes[2] = Number((now >> 24n) & 0xffn);
  bytes[3] = Number((now >> 16n) & 0xffn);
  bytes[4] = Number((now >> 8n) & 0xffn);
  bytes[5] = Number(now & 0xffn);
  const random = randomBytes(10);
  for (let i = 0; i < 10; i++) bytes[6 + i] = random[i] as number;
  bytes[6] = ((bytes[6] as number) & 0x0f) | 0x70;
  bytes[8] = ((bytes[8] as number) & 0x3f) | 0x80;
  const hex = toHex(bytes);
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

const ULID_ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

let lastUlidMs = 0;
let lastUlidRandom: Uint8Array = new Uint8Array(10);

export function ulid(opts: { monotonic?: boolean } = {}): string {
  const monotonic = opts.monotonic !== false;
  const now = Date.now();
  let randomBuf: Uint8Array;
  if (monotonic && now === lastUlidMs) {
    randomBuf = new Uint8Array(lastUlidRandom);
    for (let i = 9; i >= 0; i--) {
      const v = (randomBuf[i] as number) + 1;
      randomBuf[i] = v & 0xff;
      if (v <= 0xff) break;
    }
  } else {
    randomBuf = randomBytes(10);
  }
  lastUlidMs = now;
  lastUlidRandom = randomBuf;
  const time = encodeUlidTime(now);
  const random = encodeUlidRandom(randomBuf);
  return time + random;
}

function encodeUlidTime(ms: number): string {
  let s = '';
  for (let i = 9; i >= 0; i--) {
    const mod = ms % 32;
    s = ULID_ALPHABET[mod] + s;
    ms = (ms - mod) / 32;
  }
  return s;
}

function encodeUlidRandom(bytes: Uint8Array): string {
  let bits = 0;
  let bitCount = 0;
  let out = '';
  for (let i = 0; i < bytes.length; i++) {
    bits = (bits << 8) | (bytes[i] as number);
    bitCount += 8;
    while (bitCount >= 5) {
      bitCount -= 5;
      out += ULID_ALPHABET[(bits >> bitCount) & 31];
    }
  }
  return out.slice(0, 16);
}
